import { http } from 'connex-cds';

export default {
  listTemplates: appRef => http.get({ apiName: 'message', path: `/apps/${appRef}/templates?activeOnly=false` }),
  createTemplate: ({ template, appRef }) =>
    http.post({ apiName: 'message', path: `/apps/${appRef}/templates`, data: template }),
  updateTemplate: ({ template, appRef }) =>
    http.patch({ apiName: 'message', path: `/apps/${appRef}/templates/${template.crn}`, data: template }),
};
